import { ControllerReturnType } from "./types";

export function logAndGetErrorResponse(
  e: unknown
): Omit<ControllerReturnType, "data"> {
  try {
    console.error(`Error =====> ${logAndGetErrorResponse?.caller?.name}`, e);
  } catch (e) {
    // Intentionally left empty
  }

  if (e instanceof Error) {
    return { success: false, error: e.message };
  }
  return {
    success: false,
    error: "An unknown error occurred",
  };
}
